var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,2,1)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 10.5c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.4386 7.9385-1.8287-1.9572c-0.25035-0.26795-0.23598-0.69189 0.03197-0.94224 0.26795-0.25036 0.69189-0.23595 0.94224 0.03196l1.4106 1.5097 2.2327-2.0861c0.02008-0.01878 0.04106-0.03599 0.06276-0.05181l1.05-0.98099c0.26795-0.25035 0.69193-0.23594 0.94224 0.03201 0.25036 0.26791 0.23595 0.69189-0.03197 0.94224l-3.2068 2.9963-0.00342-0.00366-1.1093 1.0365z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 .5)",
    width: 10,
    height: 10,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f9c507bf7a5f8979fd53bbfc7e897221.svg";
export { ForwardRef as ReactComponent };